import EmblaCarousel, { type EmblaCarouselType } from 'embla-carousel'
import ClassNames from 'embla-carousel-class-names'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

const SLIDER_SELECTOR = '.rebuy-bundle__slider'
const VIEWPORT_SELECTOR = '.embla__viewport'

let emblaApi: EmblaCarouselType | null = null

function initSlider(slider: Element) {
	const viewport = slider.querySelector<HTMLElement>(VIEWPORT_SELECTOR)
	if (!viewport) return

	if (emblaApi) {
		emblaApi.destroy()
		emblaApi = null
	}

	emblaApi = EmblaCarousel(
		viewport,
		{
			align: 'start',
			containScroll: 'keepSnaps',
			dragFree: true,
		},
		[WheelGesturesPlugin(), ClassNames()],
	)
}

export function initRebuyBundleSlider() {
	const existing = document.querySelector(SLIDER_SELECTOR)
	if (existing) {
		initSlider(existing)
		return
	}

	const observer = new MutationObserver(() => {
		const slider = document.querySelector(SLIDER_SELECTOR)
		if (!slider) return
		observer.disconnect()
		initSlider(slider)
	})

	observer.observe(document.body, { childList: true, subtree: true })
}
